import React from 'react';

import TextArea from 'components/TextArea';

export const DocumentDescription = ({ onChange, value }) => (
  <TextArea
    value={value}
    onChange={onChange}
    name="description"
    label="Description"
    placeholder="Enter a file description..."
  />
);

export default DocumentDescription;
